module.exports = __webpack_public_path__ + "img/639.33f1e36c.jpg";